document.addEventListener("DOMContentLoaded", function() {
    const timerElement = document.getElementById('timer');

    function updateTimer() {
        const now = new Date();
        // Convert current time to Los Angeles time, which automatically considers PST/PDT changes
        const pstTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
        
        // Calculate next 12 PM PST/PDT
        let nextNoonPST = new Date(pstTime);
        nextNoonPST.setHours(12, 0, 0, 0); // set time to today's noon
        if (nextNoonPST <= pstTime) {
            nextNoonPST.setDate(nextNoonPST.getDate() + 1); // if it's past noon, set to next day's noon
        }

        // Calculate the difference in seconds
        const difference = Math.round((nextNoonPST - pstTime) / 1000);
        const hours = Math.floor(difference / 3600);
        const minutes = Math.floor((difference % 3600) / 60);
        const seconds = difference % 60;

        // Update the timer display
        timerElement.textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    // Update the timer every second
    setInterval(updateTimer, 1000);
    updateTimer(); // Initialize timer immediately
});

function addFreeSnackToCart(id) {
  if (window.Tapcart.isInitialized) {
    try {
    
      window.Tapcart.actions.addToCart({
        lineItems: [
            {
                variantId: id + '',
                quantity: 1,
                attributes: [
                    {
                        key: "_free_daily_snack",
                        value: 'true'
                    }
                ]
            }
        ]
    });
      Tapcart.actions.showToast({
        message: 'Added to cart',
        type: 'success', // "success" || "error"
      });
    } catch (error) {
      Tapcart.actions.showToast({
        message: error,
        type: 'error', // "success" || "error"
      });
    }
}
}